import PropTypes from 'prop-types';

import { STATUS_UNAVAILABLE, STATUS_AVAILABLE } from '../constants/book-status';

export default PropTypes.oneOf([
  STATUS_AVAILABLE,
  STATUS_UNAVAILABLE,
]);
